export default "__VITE_ASSET__cb79ef9c__"